import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import produce from 'immer';

import * as constants from './constants';
import { CertificatesAction, CertificatesStore } from './typings';

const initialState: CertificatesStore = {
    certificateList: {},
    scores: {},
};

const certificatesReducer = (state: CertificatesStore = initialState, action: CertificatesAction) => {
    return produce(state, (draft) => {
        // eslint-disable-line complexity
        switch (action.type) {
            case constants.GET_LESSON_CERTIFICATES_REQUEST: {
                const { clessonId } = action;

                draft.certificateList[clessonId] = {
                    certificates: {},
                    loadingStatus: LOADING_STATUSES.LOADING,
                };

                break;
            }

            case constants.GET_LESSON_CERTIFICATES_SUCCESS: {
                const { certificates, clessonId } = action;

                draft.certificateList[clessonId].certificates = certificates;
                draft.certificateList[clessonId].loadingStatus = LOADING_STATUSES.SUCCESS;

                break;
            }

            case constants.GET_LESSON_CERTIFICATES_ERROR: {
                const { clessonId } = action;

                draft.certificateList[clessonId].loadingStatus = LOADING_STATUSES.ERROR;
                break;
            }

            case constants.SET_LESSON_SCORES: {
                const { clessonId, scores } = action;

                draft.scores[clessonId] = scores;
                break;
            }

            default:
                break;
        }
    });
};

export default certificatesReducer;
